import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { FloppyDiscIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";

interface ISaveDataModal extends IUseModalProps {
  onConfirm: () => void;
}

export const SaveDataModal: React.FC<ISaveDataModal> = (props) => {
  const { onConfirm, ...rest } = props;
  const { t } = useTranslation();
  const modal = useModal(rest);

  return (
    <Modal
      modal={modal}
      title={t("settings.customer.saveModal.title")}
      subtitle={t("settings.customer.saveModal.subtitle")}
      actionButtons={
        <React.Fragment>
          <Button className="w-full" variant="secondary" onClick={modal.close}>
            {t("common.form.buttons.cancel")}
          </Button>
          <Button
            className="w-full"
            onClick={() => {
              onConfirm();
              modal.close();
            }}
          >
            {t("common.form.buttons.submit")}
          </Button>
        </React.Fragment>
      }
      badgeProps={{
        icon: FloppyDiscIcon,
      }}
    ></Modal>
  );
};
